<template>
  <div>
    <el-dialog v-model="dialogVisible" :width="isMobile ? '95%' : '50%'" destroy-on-close append-to-body
      :show-close="false" :before-close="handleClose" modal-class="modal-promotion-product-quick-view" :top="`2vh`">
      <div class="row">
        <div class="col-12">
          <div class="cz-product-gallery">
            <div class="cz-preview">
              <div class="cz-preview-item d-flex align-items-center justify-content-center active">
                <el-image :src="imgProxy(state.preview_image.media.url, rs = 'fill:250:250:1')"
                  :alt="dt(product.name_translations)" style="max-height: 500px!important;"
                  class="show-img img-responsive">
                  <template #error>
                    <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(product.name_translations)"
                      style="width: 100%;">
                  </template>
                </el-image>
              </div>
            </div>
            <div class="row" :style="{ margin: '0px' }">
              <div class="table-responsive" style="max-height: 515px; padding: 0px;">
                <div class="d-flex">
                  <div v-for="(image, index) in product.images" class="cz-thumblist">
                    <a href="javascript:" class=" cz-thumblist-item d-flex align-items-center justify-content-center">
                      <el-image :src="imgProxy(image.media.url, rs = 'fill:100:100:1')" alt="Product thumb"
                        class="click-img" @click="onClickImage(image)">
                        <template #error>
                          <img src="/static/assets/front-end/img/image-place-holder.png" style="width: 100%;"
                            alt="Product thumb">
                        </template>
                      </el-image>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="target != 'distributor' || isDistribute">
          <button v-if="product.select_assort_btn" class="btn btn-secondary btn-block" type="button" @click="showItem">
            {{ t("promotions.selectSpec") }}
          </button>
        </template>
      </div>

      <div class="row">
        <div class="mt-4 rtl col-12" style="text-align: left;">
          <el-tabs type="card">
            <el-tab-pane v-for="(tab, index) in dt(product.tabs_translations)" :key="tab.id" :label="tab.name"
              :name="tab.id">
              <div v-html="tab.content"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <template #footer>
        <slot name="footer"></slot>
      </template>
      <template #header="{ close, titleId, titleClass }" class="pa-0">
        <div class="d-flex" :style="{ minHeight: '60px' }">
          <a v-if="showClose" href="javascript:void(0)" @click="close" class="align-self-center mx-3">
            <i class="fa fa-close fa-2x" aria-hidden="true"></i>
          </a>
          <div class="my-header align-self-center">
            <h4 :id="titleId" :class="titleClass">
              {{ dt(product.name_translations) }}
            </h4>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, breakpoint, imgProxy } from "../../utils"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Boolean,
  product: Object,
  isDistribute: {
    type: Boolean,
    default: false,
  },
  target: String,
  showClose: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['update:modelValue', 'show', 'add'])

const { t, n, locale } = useI18n()
const dialogVisible = useVModel(props, 'modelValue', emit)

const state = reactive({
  preview_image: props.product.images ? props.product.images[0] : null
})

const isMobile = computed(() => breakpoint.value.xs)

const showItem = () => {
  dialogVisible.value = false
  emit("show", props.product)
}

const addToCart = () => {
  emit("add", props.product.assorts)
}

const handleClose = () => {
  dialogVisible.value = false
}

const onClickImage = (item) => {
  state.preview_image = item
}
</script>

<style lang="scss">
.modal-promotion-product-quick-view {

  .my-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .cz-product-gallery {
    display: block;
  }

  .cz-preview {
    width: 100%;
    margin-top: 0;
    margin-left: 0;
    max-height: 100% !important;
  }

  .cz-preview-item {
    >img {
      width: 80%;
    }
  }

  .details {
    border: 1px solid #E2F0FF;
    border-radius: 3px;
    padding: .25rem;
  }

  img {
    max-width: 100%;
    vertical-align: middle;
  }

  figure {
    max-width: 100%;
    vertical-align: middle;
  }

  .cz-thumblist-item {
    display: block;
    position: relative;
    width: 64px;
    height: 64px;
    margin: .625rem;
    transition: border-color 0.2s ease-in-out;
    border: 1px solid #E2F0FF;
    border-radius: .3125rem;
    text-decoration: none !important;
    overflow: hidden;

    >img {
      display: block;
      width: 80%;
      transition: opacity .2s ease-in-out;
      max-height: 58px;
      opacity: .6;
    }
  }

  @media (max-width: 767.98px) and (min-width: 576px) {
    .cz-preview-item {
      >img {
        width: 100%;
      }
    }
  }

  @media (max-width: 575.98px) {
    .cz-thumblist {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-pack: center;
      justify-content: center;
      margin-left: 0;
      padding-top: 1rem;
      padding-right: 22px;
      padding-bottom: 10px;
      padding-top: 8px !important;
    }

    .cz-thumblist-item {
      margin: 0px;
    }

    .cz-preview-item {
      >img {
        width: 100%;
      }
    }
  }

  .el-dialog__header {
    padding: 0;
    margin-right: 10px;

    .el-dialog__title {
      margin-bottom: 0;
    }
  }

  .el-dialog__body {
    padding: 0 10px 10px;
  }

  .el-dialog__footer {
    padding: 10px;
  }
}
</style>